import React, { useState, useEffect } from 'react';
import './sidebar.css';
import { Link, useLocation } from 'react-router-dom';
import {
  FaBars, FaTachometerAlt, FaCalendarDay, FaMoneyBillWave,
  FaHandHoldingUsd, FaFileAlt, FaUserFriends, FaLeaf,
  FaUserTie, FaIndustry, FaCalendarAlt, FaSignOutAlt, FaChevronDown
} from 'react-icons/fa';

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false); // ⬅️ full sidebar default
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSidebarVisible, setIsSidebarVisible] = useState(window.innerWidth > 768);
  const [openDropdown, setOpenDropdown] = useState({
    reports: false,
    collection: false,
    details: false,
  });

  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(false); // ✅ show full sidebar (not icon-only)
        setIsSidebarVisible(false); // ✅ hidden until hamburger clicked
      } else {
        setCollapsed(false); // ✅ desktop default full sidebar
        setIsSidebarVisible(true);
      }
    };

    handleResize(); // run once initially
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) setIsSidebarVisible(false);
  }, [location.pathname]);

  const toggleSidebar = () => {
    if (isMobile) {
      setIsSidebarVisible(!isSidebarVisible);
    } else {
      setCollapsed(prev => !prev);
    }
  };

  const handleMenuClick = () => {
    if (isMobile) setIsSidebarVisible(false);
  };

  const toggleDropdown = (menu) => {
    setOpenDropdown(prev => ({
      ...Object.fromEntries(Object.keys(prev).map(k => [k, false])),
      [menu]: !prev[menu],
    }));
  };

  const isActive = (path) => location.pathname === path;

  const sidebarClass = `sidebardata 
    ${!isMobile && collapsed ? 'collapsed' : ''} 
    ${isMobile && isSidebarVisible ? 'mobile-open' : ''} 
    ${isMobile && !isSidebarVisible ? 'mobile-hidden' : ''}
  `;
const handleLogout = () => {
  localStorage.removeItem('user'); // Clear stored login
  window.location.href = '/login'; // Redirect to login
};

  return (
    <>
      <div className="toggle-btn" onClick={toggleSidebar}>
        <FaBars />
      </div>

      <div className={sidebarClass.trim()}>
        <h2 className="sidebar-title">
          <span className="full-title">Kammandhu KM Tea</span>
          <span className="short-title">KM</span>
        </h2>

        <ul>
          <li className={isActive('/dashboard/') ? 'active' : ''}>
            <Link to="/dashboard/" onClick={handleMenuClick}><FaTachometerAlt /><span>Dashboard</span></Link>
          </li>
          <li className={isActive('/dashboard/today') ? 'active' : ''}>
            <Link to="/dashboard/today" onClick={handleMenuClick}><FaCalendarDay /><span>Today</span></Link>
          </li>
          <li className={isActive('/dashboard/dailyexp') ? 'active' : ''}>
            <Link to="/dashboard/dailyexp" onClick={handleMenuClick}><FaMoneyBillWave /><span>Expenses</span></Link>
          </li>
          <li className={isActive('/dashboard/advance') ? 'active' : ''}>
            <Link to="/dashboard/advance" onClick={handleMenuClick}><FaHandHoldingUsd /><span>Adv Payments</span></Link>
          </li>

          <li className={`dropdown-link ${openDropdown.reports ? 'open' : ''}`}>
            <div onClick={() => toggleDropdown('reports')}>
              <FaFileAlt /><span>Reports</span><FaChevronDown className="chevron" />
            </div>
            <ul className="dropdown-items">
              <li><Link to="/dashboard/farmreports" onClick={handleMenuClick}><FaFileAlt /> Tea Report</Link></li>
              <li><Link to="/dashboard/factoryreports" onClick={handleMenuClick}><FaFileAlt /> Factory Report</Link></li>
              <li><Link to="/dashboard/advancereports" onClick={handleMenuClick}><FaFileAlt /> Advance Report</Link></li>
              <li><Link to="/dashboard/expensesreports" onClick={handleMenuClick}><FaFileAlt /> Expense Report</Link></li>
            </ul>
          </li>

          <li className={`dropdown-link ${openDropdown.collection ? 'open' : ''}`}>
            <div onClick={() => toggleDropdown('collection')}>
              <FaLeaf /><span>Collections</span><FaChevronDown className="chevron" />
            </div>
            <ul className="dropdown-items">
              <li><Link to="/dashboard/collect" onClick={handleMenuClick}><FaLeaf /> Tea Collection</Link></li>
              <li><Link to="/dashboard/factorydata" onClick={handleMenuClick}><FaIndustry /> Factory Data</Link></li>
            </ul>
          </li>

          <li className={`dropdown-link ${openDropdown.details ? 'open' : ''}`}>
            <div onClick={() => toggleDropdown('details')}>
              <FaCalendarAlt /><span>Details</span><FaChevronDown className="chevron" />
            </div>
            <ul className="dropdown-items">
              <li><Link to="/dashboard/farmer" onClick={handleMenuClick}><FaUserFriends /> Farmers</Link></li>
              <li><Link to="/dashboard/factory" onClick={handleMenuClick}><FaIndustry /> Factory</Link></li>
              <li><Link to="/dashboard/employee" onClick={handleMenuClick}><FaUserTie /> Employee</Link></li>
            </ul>
          </li>

          <li><Link to="/dashboard/monthly" onClick={handleMenuClick}><FaCalendarAlt /><span>Payments</span></Link></li>
       <li>
  <div onClick={handleLogout} >
    <FaSignOutAlt /><span>Log Out</span>
  </div>
</li>

        </ul>
      </div>
    </>
  );
};

export default Sidebar;
